function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
import { tenantList } from "./tenantlist.js";
/**
 * Returns fully formatted object.
 * @param {object} obj - data layer object.
 * @return {function name(params) { }}} - Returns the formatted object using all format functions
 */

var formatAirlines = function formatAirlines(obj) {
  if (obj.hasOwnProperty("module") && obj.module != "" && obj.hasOwnProperty("eventAction") && obj.eventAction != "") {
    return addParameters(obj), convertValues(obj), formatJourney(obj), formatFareClass(obj), formatCase(obj), formatTenantType(obj), formatDate(obj), formatUrl(obj), pushFormattedEventData(obj);
  }
  return "Module name or eventAction missing.";
};
var formatHotels = function formatHotels(obj) {
  if (obj.hasOwnProperty("module") && obj.module != "" && obj.hasOwnProperty("eventAction") && obj.eventAction != "") {
    return convertValues(obj), formatCase(obj), formatTenantType(obj), formatDate(obj), formatUrl(obj), pushFormattedEventData(obj);
  }
  return "Module name or eventAction missing.";
};
var formatEvents = function formatEvents(obj) {
  if (obj.hasOwnProperty("module") && obj.module != "" && obj.hasOwnProperty("eventAction") && obj.eventAction != "") {
    return convertValues(obj), formatJourney(obj), formatFareClass(obj), formatCase(obj), formatTenantType(obj), formatDate(obj), formatUrl(obj), pushFormattedEventData(obj);
  }
  return "Module name or eventAction missing.";
};

/**
 * Adds moduleId and tagName parameters if they are not in the given object.
 * @param {object} obj - data layer object.
 * @return {object} - Returns the formatted object with the parameters as needed.
 */

var addParameters = function addParameters(obj) {
  if (!obj.hasOwnProperty("moduleId")) {
    obj.moduleId = "";
  }
  if (!obj.hasOwnProperty("tagName")) {
    obj.tagName = "";
  }
  return obj;
};

/**
 * Formats journey type to ONE_WAY or ROUND_TRIP.
 * @param {object} obj - data layer object.
 * @return {object} - Returns formatted journey type.
 */

var formatJourney = function formatJourney(obj) {
  if (obj.hasOwnProperty("journeyType")) {
    if (obj.journeyType.match(/(oneway|one-way|one_way|ow|one way)/gi)) {
      obj.journeyType = "ONE_WAY";
    } else if (obj.journeyType.match(/(roundtrip|round-trip|round_trip|rt|round trip)/gi)) {
      obj.journeyType = "ROUND_TRIP";
    } else {
      return obj.journeyType = "";
    }
  }
  return obj;
};

/**
 * Formats fareClass to ECONOMY, BUSINESS, or FIRST.
 * @param {object} obj - data layer object.
 * @return {object} - Returns formatted fare class.
 */

var formatFareClass = function formatFareClass(obj) {
  if (obj.hasOwnProperty("fareClass")) {
    if (obj.fareClass.match(/(economy|ec|^e$)/gi)) {
      obj.fareClass = "ECONOMY";
    } else if (obj.fareClass.match(/(business|bc|^b$|businessclass)/gi)) {
      obj.fareClass = "BUSINESS";
    } else if (obj.fareClass.match(/(first|fc|^f$|firstclass)/gi)) {
      obj.fareClass = "FIRST";
    } else {
      obj.fareClass = "";
    }
  }
  return obj;
};

/**
 * Formats provider. Can only format the provider name if it is separated by spaces.
 * @deprecated - providers are now separated by spaces only
 * @param {object} obj - data layer object.
 * @return {object} - Returns formatted provider name.
 */

var formatProvider = function formatProvider(obj) {
  if (obj.hasOwnProperty("provider")) {
    var airlineName = obj.provider;
    var finalAirlineName = "";
    if (airlineName.match(/[a-zA-Z0-9]+/g)) {
      var airlineArray = airlineName ? airlineName.split(" ") : [];
      if (airlineArray && airlineArray.length > 0) {
        airlineArray.forEach(function (key) {
          finalAirlineName += key.charAt(0).toUpperCase() + key.slice(1).toLowerCase();
        });
        return obj.provider = finalAirlineName;
      } else {
        return "";
      }
    }
  }
};

/**
 * Formats casing for different key values.
 * Events, Module, eventAction - kebab-case
 * lodging name - Titlecased
 * Rest - Capital
 * @param {object} obj - data layer object.
 * @return {object} - Returns case-converted object.
 */
var formatCase = function formatCase(obj) {
  var keyArr = ["event", "module", "eventAction", "airlineIataCode", "originAirportIataCode", "destinationAirportIataCode", "currencyCode", "route", "countryIsoCode", "cityCode", "languageIsoCode", "siteEdition", "name", "provider",
  //Hotel values
  "tenantCode", "actionLabel", "regionName", "countryCode", "cityName", "propertyName",
  //Event values
  "eventName", "eventLocation", "eventSession", "eventExperienceCategory", "eventExperience"];
  var listOfEvents = ["change-budget", "change-departure-date", "change-destination", "change-fare-class", "change-journey-type", "change-location", "change-miles", "change-month", "change-origin", "change-rating", "change-return-date", "change-status", "change-trip-length", "click-out", "collapse-form", "collapse-histogram", "expand-flight", "expand-form", "expand-map", "filter-airlines", "flight", "fsi", "more-deals", "open-booking-popup", "read-article", "reset-filter", "search-initiation", "search", "select-accessibility", "select-date", "select-end-date", "select-experience", "select-interest", "select-location", "select-map-destination", "select-month", "select-night", "select-offer", "select-property", "select-redemption", "select-room-guest", "select-start-date", "select-stay-length", "select-stop", "select-tab", "selected-travel-interest", "sort", "toggle-farelist", "zoom", "viewable-impression", "select-article", "select-resident-status", "no-fares-available", "insert-first-name", "insert-last-name", "select-origin", "insert-email", "insert-phone-number", "subscribe"];
  var titleCase = ["regionName", "cityName", "propertyName", "eventName", "eventLocation", "eventSession", "eventExperienceCategory", "eventExperience", "provider"];
  keyArr.forEach(function (key) {
    if (obj.hasOwnProperty(key)) {
      if (key === "event" || key === "module" || key === "actionLabel") {
        obj[key] = obj[key].replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
        var found = listOfEvents.includes(obj["event"]);
        if (!found && key === "event") {
          obj["event"] = "Event value does not exist";
          console.log("Error: Please check event value");
        }
      } else if (key === "eventAction") {
        obj.eventAction = obj.hasOwnProperty("event") && obj.event != "" ? obj.event : obj.eventAction;
      } else if (titleCase.includes(key)) {
        //To titlecase. Check if key is eventExperience and contains multiple values -> else replace to titlecase.
        obj[key] = key === "eventExperience" && obj[key].match(/(multiple|,)/gi) ? "MULTIPLE" : obj[key].toLowerCase().includes("n/a") ? '' : obj[key].replace(/\w\S*/g, function (match) {
          return match.charAt(0).toUpperCase() + match.slice(1).toLowerCase();
        });
      } else {
        obj[key] = obj[key].toUpperCase();
      }
    }
    if (obj.page !== undefined) {
      if (obj.page[0].hasOwnProperty(key) && (key === "languageIsoCode" || key === "siteEdition" || key === "countryIsoCode")) {
        var _obj$page$0$countryIs, _obj$page$0$countryIs2, _obj$page$0$languageI, _obj$page$0$languageI2, _siteEdition$;
        var siteEdition = obj.page[0].siteEdition.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").split("-");
        obj.page[0].countryIsoCode = (_obj$page$0$countryIs = (_obj$page$0$countryIs2 = obj.page[0].countryIsoCode) === null || _obj$page$0$countryIs2 === void 0 ? void 0 : _obj$page$0$countryIs2.toUpperCase()) !== null && _obj$page$0$countryIs !== void 0 ? _obj$page$0$countryIs : "";
        obj.page[0].languageIsoCode = (_obj$page$0$languageI = (_obj$page$0$languageI2 = obj.page[0].languageIsoCode) === null || _obj$page$0$languageI2 === void 0 ? void 0 : _obj$page$0$languageI2.toLowerCase()) !== null && _obj$page$0$languageI !== void 0 ? _obj$page$0$languageI : "";
        obj.page[0].siteEdition = siteEdition[1] !== undefined ? siteEdition[0] + "-" + siteEdition[1].toUpperCase() : obj.page[0].siteEdition === "" && obj.page[0].languageIsoCode && obj.page[0].countryIsoCode !== '' ? obj.page[0].languageIsoCode + "-" + obj.page[0].countryIsoCode : (_siteEdition$ = siteEdition[0]) !== null && _siteEdition$ !== void 0 ? _siteEdition$ : "";
      }
    }
    if (obj.lodging !== undefined) {
      if (obj.lodging[0].hasOwnProperty(key) && key == "cityCode") {
        var _obj$lodging$0$cityCo, _obj$lodging$0$cityCo2;
        obj.lodging[0].cityCode = (_obj$lodging$0$cityCo = (_obj$lodging$0$cityCo2 = obj.lodging[0].cityCode) === null || _obj$lodging$0$cityCo2 === void 0 ? void 0 : _obj$lodging$0$cityCo2.toUpperCase()) !== null && _obj$lodging$0$cityCo !== void 0 ? _obj$lodging$0$cityCo : "";
      }
      if (obj.lodging[0].hasOwnProperty(key) && key === "name") {
        var _ref, _obj$lodging$0$name, _obj$lodging$0$name2;
        obj.lodging[0].name = (_ref = ((_obj$lodging$0$name = obj.lodging[0].name) === null || _obj$lodging$0$name === void 0 ? void 0 : _obj$lodging$0$name.charAt(0).toUpperCase()) + ((_obj$lodging$0$name2 = obj.lodging[0].name) === null || _obj$lodging$0$name2 === void 0 ? void 0 : _obj$lodging$0$name2.substr(1).toLowerCase())) !== null && _ref !== void 0 ? _ref : "";
      }
    }
  });
  return obj;
};

/**
 * Formats date to ISO format.
 * @param {object} obj - data layer object.
 * @return {object} - Returns formatted dates.
 */

var formatDate = function formatDate(obj) {
  var dateArr = ["departureDate", "returnDate", "timestamp", "startDate", "endDate"];
  dateArr.forEach(function (key) {
    if (obj.hasOwnProperty(key)) {
      if (key === "timestamp") {
        obj[key] = new Date(obj[key]).toISOString();
      } else if (obj[key] !== '') {
        obj[key] = new Date(obj[key]).toISOString().substr(0, 10);
      } else {
        obj[key] = '';
      }
    }
    if (obj.lodging !== undefined) {
      if (obj.lodging[0].hasOwnProperty(key) && (key === "startDate" || key === "endDate")) {
        obj.lodging[0][key] = new Date(obj.lodging[0][key]).toISOString().substr(0, 10);
      }
    }
  });
  return obj;
};

/**
 * Checks whether the document/page is in an iFrame
 * @return {boolean} - Returns truthy or falsy value
 */
var checkIframe = function checkIframe() {
  try {
    if (window.self !== window.top || window.location !== window.parent.location) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return true;
  }
};

/**
 * Formats url spacing.
 * @param {object} obj - data layer object.
 * @return {object} - Returns url spaced between : and /.
 */
var formatUrl = function formatUrl(obj) {
  if (obj.hasOwnProperty("url")) {
    if (obj["url"] !== '') {
      obj.url;
    } else if (checkIframe()) {
      obj.url = window.parentURL !== '' ? window.parentURL : document.referrer || window.parent.location.href;
    } else {
      obj.url = document.location.href;
    }
    obj.url = obj.url.split(":").join(": ");
  }
  return obj;
};

/**
 * Recursive Function.
 * Replaces null values to empty string.
 * Converts numeric string values to their number value.
 * Converts true/false string values to their boolean values
 * @param {object} obj - data layer object.
 * @return {object} - Returns formatted object.
 */
var convertValues = function convertValues(obj) {
  for (var property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (_typeof(obj[property]) === "object") {
        convertValues(obj[property]);
        if (obj[property] == null) {
          obj[property] = "";
        }
      } else if (typeof obj[property] === "string" && !isNaN(obj[property]) && !isNaN(parseFloat(obj[property]))) {
        obj[property] = +obj[property];
      } else {
        if (typeof obj[property] === "string" && (obj[property] === "false" || obj[property] === "true")) {
          obj[property] = obj[property].toLowerCase() === 'true' ? true : false;
        }
      }
      if (typeof obj[property] === 'number') {
        obj[property] = Math.round(obj[property] * 100) / 100;
      }
    }
  }
  return obj;
};

/**
 * Returns tenant type based on tenant code. Checks whether tenant code belongs in tenant list. 
 * @param  {object} obj - formatted object
 * @return {object} - returns object containing tenant type
 */
var formatTenantType = function formatTenantType(obj) {
  var tenantCode = obj.hasOwnProperty('tenantCode') ? obj['tenantCode'] : obj.hasOwnProperty('airlineIataCode') ? obj['airlineIataCode'] : '';
  var tenantCodeSubstr = tenantCode.substring(0, tenantCode.length - 1); //Take substring for customers with multiple tenants

  //Check if tenant belongs in list
  if (Object.keys(tenantList).includes(tenantCode)) {
    return obj.tenantType = tenantList[tenantCode];
  }
  //If the tenant code does not belong to list
  else if (!Object.keys(tenantList).includes(tenantCode)) {
    //Check if substring of tenant code belongs in list
    if (Object.keys(tenantList).includes(tenantCodeSubstr)) {
      return obj.tenantType = tenantList[tenantCodeSubstr];
    } else {
      switch (tenantCode[0].toUpperCase()) {
        case "A":
          obj.tenantType = "airline";
          break;
        case "X":
          obj.tenantType = "airline alliance";
          break;
        case "L":
          obj.tenantType = "airport";
          break;
        case "P":
          obj.tenantType = "package";
          break;
        case "H":
          obj.tenantType = "hotel";
          break;
        case "E":
          obj.tenantType = "event";
          break;
        case "B":
          obj.tenantType = "bus";
          break;
        case "D":
          obj.tenantType = "tourism board & dmo";
          break;
        case "T":
          obj.tenantType = "train";
          break;
        default:
          obj.tenantType = '';
          console.log('tenantCode does not adhere to the naming convention.');
      }
      return obj;
    }
  }
};
/**
 * Pushes formatted object to datalayer
 * @param  {object} obj - formatted object
 */
var pushFormattedEventData = function pushFormattedEventData(obj) {
  if (!window) {
    console.error('window is not defined');
  } else {
    if (window.utag) {
      window.utag.link(obj);
    }
    if (window.dataLayer) {
      if (window.localDataLayer && window.localDataLayer.length > 0) {
        var _window$dataLayer;
        (_window$dataLayer = window.dataLayer).push.apply(_window$dataLayer, _toConsumableArray(window.localDataLayer));
        window.localDataLayer = [];
      }
      window.dataLayer.push(obj);
    } else {
      window.localDataLayer = [];
      window.localDataLayer.push(obj);
    }
  }
};
var formatter = {
  formatAirlines: formatAirlines,
  formatHotels: formatHotels,
  formatEvents: formatEvents
};
export default formatter;